import { LocalStorageService } from '../LocalStorageService'

 const CookiesService = {

    acceptedCookiesKey: 'cookies_accepted',
    /** Accept Cookies and store this info in local storage
     */
    acceptCookies: () => {
        LocalStorageService.set(CookiesService.acceptedCookiesKey, true);
    },
    /** Check if cookies accapted
     * @return {bool} Checking if cookies accepted or not
    */
    isCookiesAccapted: () => {
        const isCookiesAccapted = !!LocalStorageService.get(CookiesService.acceptedCookiesKey);
        return isCookiesAccapted;
    },
}
export default CookiesService;